import geModifierGroupTitleTemplateService
  from '~/src/components/products/modifier-groups/modifier-group/modifier-group-title/styles/geModifierGroupTitleTemplateService'
import { useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import useGetComponentStyle from '~/src/hooks/layout/useGetComponentStyle'

const useModifierGroupTitleTemplateService = () => {
  const muiTheme = useCustomMuiTheme()
  const componentStyle = useGetComponentStyle('modifiers')

  return geModifierGroupTitleTemplateService(componentStyle, muiTheme)
}

export default useModifierGroupTitleTemplateService
